import * as types from './mutation_types'

export const toggleTask = ({ commit }, payload) => {
  commit(types.TOGGLE_TASK, payload)
}

export const addTask = ({ commit }, payload) => {
  commit(types.ADD_TASK, payload)
}
